<template>
	<div class="drawer-header">
		<el-row>
      <el-col :span="8" style="padding-right: 20px;">
				<div class="box-card">
					<div>
						<div style="font-size: 20px;font-weight: bold;padding-bottom: 8px;">
							{{ data ? data.shop_name ? data.shop_name : '' : '' }}
						</div>
						<div style="width: 100%;clear: both;">
							<div style="float: left;padding-bottom: 8px;">
								{{data.platform_code | platformChinese}}
							</div>
							<div style="float: right;color: #00000072;padding-bottom: 8px;">
								{{ data.campaignway === 0 ? '按产品申报' : data.campaignway === 1 ? '按链接申报' : '全店铺申报' }}
							</div>
						</div>
						<div v-if="isApprovalDetail" style="width: 100%;clear: both;">
							<div style="font-size: 16px;font-weight: bold;float: left;">
								店铺历史活动信息
							</div>
							<div class="down-icon" @click="onOpenHistory" style="float: right;color: #1890FF;padding-top: 4px;">
								更多信息
								<i v-if="historyVisible" class="el-icon-arrow-up"></i>
								<i v-else class="el-icon-arrow-down"></i>
							</div>
						</div>

						<div style="width: 100%;clear: both;padding: 8px 0;">
						  <span>近90天审核通过链接:</span>
						  <span>&nbsp;&nbsp; {{ allData.count }}条</span>
						</div>
						<div style="width: 100%;clear: both;padding-bottom: 8px;">
						  <span>近90天全店活动次数:</span>
						  <span>&nbsp;&nbsp; {{ allData.shopcount }}次</span>
						  <el-popover v-if="allData.getshopdetails.length" class="drawer-pop" placement="bottom" trigger="hover">
						    <div v-for="item in allData.getshopdetails" :key="item">
						      <span>{{ item.discounts }}折</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						      <span>{{ item.discountsnum }}次</span>
						    </div>
						    <div slot="reference">
						      <i class="el-icon-question"></i>
						    </div>
						  </el-popover>
						</div>
						<div>
							<span>最近活动结束时间:</span>
							<span v-if="allData.c">&nbsp;&nbsp;
		            {{ allData.c.end_time|fullTime }}
		            <el-popover class="drawer-pop" placement="bottom" trigger="hover">
		              <span
		                style="display:block"
		              >{{ `${allData.c.campaign_name}（${allData.c.activity_number}）` }}</span>
		              <span
		                style="display:block"
		              >{{ allData.c.start_time|fullTime }} ~ {{allData.c.end_time|fullTime}}</span>
		              <div slot="reference">
		                <i class="el-icon-question"></i>
		              </div>
		            </el-popover>
							</span>
						</div>
					</div>
				</div>
      </el-col>
			<el-col :span="16">
				<div class="box-card">
					<div>
						<div style="font-size: 16px;font-weight: bold;padding-bottom: 8px;">
							{{data.campaign_name}}
						</div>
						<div style="width: 100%;clear: both;">
							<div style="width: 50%;float: left;padding-bottom: 8px;">
								<span style="color: #00000072;">
									活动单号：
								</span>
								<span>
									{{data.activity_number}}
								</span>
							</div>
							<div style="width: 50%;float: left;padding-bottom: 8px;">
								<span style="color: #00000072;">
									提交时间：
								</span>
								<span v-if="data.createtime">
									{{data.createtime| fullTime}}
								</span>
								<span v-else>
									--
								</span>
							</div>
						</div>
						<div style="width: 100%;clear: both;">
							<div style="width: 50%;float: left;padding-bottom: 8px;">
								<span style="color: #00000072;">
									预热时间：
								</span>
								<span v-if="data.preheating_time">
									{{data.preheating_time | fullTime}}
								</span>
								<span v-else>
									--
								</span>
							</div>
							<div style="width: 50%;float: left;padding-bottom: 8px;">
								<span style="color: #00000072;">
									活动时间：
								</span>
								<span v-if="data.start_time && data.end_time">
									{{data.start_time | fullTime}} - {{data.end_time | fullTime}}
								</span>
								<span v-else>
									--
								</span>
							</div>
						</div>
						<div>
							<span style="color: #00000072;">
								活动说明：
							</span>
							<span>
								{{data.campaign_desc}}
							</span>
						</div>
						<div v-if="isApprovalDetail" style="padding-top: 8px;">
							<span style="color: #00000072;">附件：</span>
								<span v-if="data.attachment">
		            <span v-for="(item, i) in hanldeAttachmentName()" :key="i">
									<el-link
										v-if="item.needShow"
										@click="onShowFile(data.attachment.split(',')[i])"
										type="primary"
										:underline="false"
									>
										<span>{{ item.file }} &nbsp;&nbsp;</span>
									</el-link>
									<span v-else>{{ item.file }} &nbsp;&nbsp;</span>
									<i style="color: #108cee; cursor: pointer" @click="onDownFile(data.attachment.split(',')[i])" class="el-icon-download"></i>
									&nbsp;&nbsp;
		            </span>
		          </span>
						</div>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-card class="history_main" v-if="isApprovalDetail && historyVisible">
				<div>
					<span class="drawer-card-key">近90天审核通过链接:</span>
					<span>&nbsp;&nbsp; {{ allData.count }}条</span>
				</div>
				<div>
					<span class="drawer-card-key">近90天全店活动次数:</span>
					<span>&nbsp;&nbsp; {{ allData.shopcount }}次</span>
					<el-popover v-if="allData.getshopdetails.length" class="drawer-pop" placement="bottom" trigger="hover">
						<div v-for="item in allData.getshopdetails" :key="item">
							<span>{{ item.discounts }}折</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							<span>{{ item.discountsnum }}次</span>
						</div>
            <div slot="reference">
              <i class="el-icon-question"></i>
            </div>
          </el-popover>
				</div>
				<div style="display: flex">
					<span class="drawer-card-key">近90天申请商品TOP3:</span>
					<div>
						<div v-for="(item, index) in allData.list" :key="index">
							<span style="display: inline-block;max-width: 500px;">&nbsp;&nbsp; {{ item.productInfo }}</span>
							<span style="display: inline-block;margin-left: 30px;">{{ item.productcount }}次</span>
						</div>
					</div>
				</div>
				<div>
					<span class="drawer-card-key">最近活动结束时间:</span>
					<span v-if="allData.c">&nbsp;&nbsp;
            {{ allData.c.end_time|fullTime }}
            <el-popover class="drawer-pop" placement="bottom" trigger="hover">
              <span
                style="display:block"
              >{{ `${allData.c.campaign_name}（${allData.c.activity_number}）` }}</span>
              <span
                style="display:block"
              >{{ allData.c.start_time|fullTime }} ~ {{allData.c.end_time|fullTime}}</span>
              <div slot="reference">
                <i class="el-icon-question"></i>
              </div>
            </el-popover>
					</span>
				</div>
      </el-card>
	</div>
</template>

<script>
import Shopname from 'components/shopname/Shopname'
export default {
	name: 'activityHeader',

	props: {
		// 是否是审批详情页的标记位
		isApprovalDetail: {
			type: Boolean
		},
		data: {
			type: Object,
			default: () => {
				return {
					shop_name: '',
					campaignway: 0,
					platform_code: 'TB',
					dict_code: 'TB'
				}
			}
		},
		// 详情页全部的数据
		allData: {
			type: Object
		}
	},

	components:{
		Shopname
	},

	data () {
		return {
			historyVisible: false,
		}
	},

	methods: {
		hanldeAttachmentName() {
      let attachment = this.data.attachment;
      let attachmentArr = attachment.split(",");
      let res = attachmentArr.map(item => {
				let obj = {};
				obj.file = item.substring(item.lastIndexOf("_") + 1);
				if(/\.(jpg|png)$/.test(item)) {
					obj.needShow = true;
				}
        return obj;
      });
      return res;
		},
		onDownFile(file) {
			let url = `hcm/hcmWorkOrder/downLoadFile?filename=${file}`;
			window.open(url);
		},
		onShowFile(file) {
			let url = `https://hawksights.obs.cn-east-2.myhuaweicloud.com/${file}`
			window.open(url);
    },
		onOpenHistory() {
			this.historyVisible = !this.historyVisible;
		},
	},

	computed: {},

	mounted(){
		console.log(this.allData);

	}
}
</script>

<style lang="scss" scoped>
$highColor:#108cee;

// .drawer-header .el-drawer__close-btn {
// 	position: absolute;
//     right: 20px;
//     top: 20px;
// }
.drawer-card-key {
	display: inline-block;
	width: 155px;
	text-align: right;
  padding-right: 5px;
  color: #9F9F9F;
}

.box-card {
	margin: 20px;
}

.drawer-header {
	position: relative;

	.left-box {
		display: inline-flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		max-width: 500px;
		min-width: 200px;
		height: 135px;
		padding-left: 10px;
		padding-right: 10px;
		border-right: 1px solid #bda571;
	}

	.item-center {
		display: flex;
		justify-content: center;

		.down-icon {
			line-height: 1.5;
			color: $highColor;
			cursor: pointer;
		}
	}

	.approval-box {
		width: 100px;
		height: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
		border: 1px solid #D3A977;
		border-radius: 5px;
		color: #D3A977;
	}

	.right-box {
		display: inline-flex;
		height: 135px;
    max-height: 175px;
    line-height: 1.9;
		flex-direction: column;
		justify-content: center;
		position: absolute;
		margin-left: 20px;
	}

	.history_main {
		font-size: 15px;
	}

  .drawer-title {
    font-size: 1.3em;
    line-height: 1;
  }

  .drawer-info-box {
		display: flex;
		justify-content: center;
    align-items: center;

    .drawer-shop {
      font-size: 17px;
      line-height: 1;
    }

    .drawer-platform {
      margin-left: 20px;
      margin-right: 20px;
      width: 25px;
      height: 25px;
      border-radius: 3px;
    }

    // .drawer-agency {
    //   display: block;
    //   overflow: hidden;
    //   text-overflow: ellipsis;
    //   white-space: nowrap
    // }
  }

  // .drawer-approval-state {
  //   text-align: right;
  //   margin-right: 20px;
  //   i {
  //     font-size: 35px;
  //   }

  //   span {
  //     display: inline-block;
  //     margin-left: 10px;
  //     font-size: 25px;
  //   }
  // }

}
</style>
